export default __webpack_public_path__ + "src/assets/icn-how-do-i-buy-crypto.96531d626b0fde380891ec2e296ccb89.svg";